export default __webpack_public_path__ + "static/media/messageStock.12a32927.jpg";